<form [formGroup]="formGroup()" class="row gap-4">
  <div class="col-12">
    <div>
      <fieldset class="p-3 border rounded h-100">
        <legend class="float-none w-auto px-2">
          {{ 'SETTINGS.VEHICLE_PERFORMANCE_AND_DISTANCE' | translate }}
        </legend>
        <div class="row g-3">
          <!-- NAME -->
          <div class="col-12 col-md-6">
            <app-form-input
              [id]="'name'"
              [label]="'SETTINGS.NAME' | translate"
              [controlName]="'name'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'text'"/>
          </div>
          <!-- AVERAGE_KM_BUS -->
          <div class="col-12 col-md-6">
            <app-form-input
              [id]="'averageKmBus'"
              [label]="'SETTINGS.AVERAGE_KM_BUS' | translate"
              [controlName]="'averageKmBus'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'text'"/>
          </div>
        <!-- MAX_KM_HARD -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'maxKmHard'"
            [label]="'SETTINGS.MAX_KM_HARD' | translate"
            [controlName]="'maxKmHard'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'text'"/>
        </div>
          <!-- MAX_KM_SOFT -->
          <div class="col-12 col-md-6">
            <app-form-input
              [id]="'maxKmSoft'"
              [label]="'SETTINGS.MAX_KM_SOFT' | translate"
              [controlName]="'maxKmSoft'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'text'"/>
          </div>

        <!-- PERSONS PER BUS -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'busCapacity'"
            [label]="'SETTINGS.PERSONS_PER_BUS' | translate"
            [controlName]="'busCapacity'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"/>
        </div>
        </div>
      </fieldset>
    </div>

    <div>
      <div class="col-12">
    <fieldset class="p-3 border rounded">
      <legend class="float-none w-auto px-2">
        {{ 'SETTINGS.TIME_MANAGEMENT' | translate }}
      </legend>
      <div class="row g-3">
        <!-- START_DAY_OFFSET -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'startDayOffset'"
            [label]="'SETTINGS.START_DAY_OFFSET' | translate"
            [controlName]="'startDayOffset'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>
        <!-- START_CALCULATION_TIME -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'startTime'"
            [label]="'SETTINGS.START_CALCULATION_TIME' | translate"
            [controlName]="'startTime'"
            [formGroup]="formGroup()"
            [type]="'hour-minute'"
            [isRequired]="true"/>
        </div>

        <!-- BUFFER_TIME -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'bufferTime'"
            [label]="'SETTINGS.BUFFER_TIME' | translate"
            [controlName]="'bufferTime'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'text'"
          />
        </div>
        <!-- TOTAL_DRIVING_TIME_SOFT -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'totalDrivingTimeSoft'"
            [label]="'SETTINGS.TOTAL_DRIVING_TIME_SOFT' | translate"
            [controlName]="'totalDrivingTimeSoft'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>
        <!-- MAX_DRIVING_TIME_SOFT -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'maxDrivingTimeSoft'"
            [label]="'SETTINGS.MAX_DRIVING_TIME_SOFT' | translate"
            [controlName]="'maxDrivingTimeSoft'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>
        <!-- MAX_DRIVING_TIME_HARD -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'maxDrivingTimeHard'"
            [label]="'SETTINGS.MAX_DRIVING_TIME_HARD' | translate"
            [controlName]="'maxDrivingTimeHard'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>
        <!-- GAS_STOP_AMOUNT -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'gasStopAmount'"
            [label]="'SETTINGS.GAS_STOP_AMOUNT' | translate"
            [controlName]="'gasStopAmount'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>
        <!--GAS_STOP_DURATION-->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'gasStopDuration'"
            [label]="'SETTINGS.GAS_STOP_DURATION' | translate"
            [controlName]="'gasStopDuration'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"/>
        </div>
        <!-- PAUSE AMOUNT -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'pauseAmount'"
            [label]="'SETTINGS.PAUSE_AMOUNT' | translate"
            [controlName]="'pauseAmount'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'text'"
          />
        </div>
        <!-- PAUSE DURATION -->
        <div class="col-12 col-md-6">
          <app-form-input
            [id]="'pauseDuration'"
            [label]="'SETTINGS.PAUSE_DURATION' | translate"
            [controlName]="'pauseDuration'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"
          />
        </div>

        </div>
      </fieldset>
    </div>
  </div>

  <div class="col-12">
    <fieldset class="p-3 border rounded">
      <legend class="float-none w-auto px-2">
        {{ 'SETTINGS.STOPS' | translate }}
      </legend>
      <div class="row g-3">
        <!-- PICKUP_DURATION -->
        <div class="col-12 col-md-4">
          <app-form-input
            [id]="'uebergabeStopDuration'"
            [label]="'SETTINGS.PICKUP_DURATION' | translate"
            [controlName]="'uebergabeStopDuration'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"/>
        </div>
        <!-- EXCHANGE_DURATION -->
        <div class="col-12 col-md-4">
          <app-form-input
            [id]="'wechselStopDuration'"
            [label]="'SETTINGS.EXCHANGE_DURATION' | translate"
            [controlName]="'wechselStopDuration'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"/>
        </div>
        <!--TAKEOFF_DURATION-->
        <div class="col-12 col-md-4">
          <app-form-input
            [id]="'abholungStopDuration'"
            [label]="'SETTINGS.TAKEOFF_DURATION' | translate"
            [controlName]="'abholungStopDuration'"
            [formGroup]="formGroup()"
            [isRequired]="true"
            [type]="'number'"/>
        </div>
      </div>
    </fieldset>
  </div>
    <div class="col-12">
      <fieldset class="p-3 border rounded">
        <legend class="float-none w-auto px-2">
          {{ 'SETTINGS.PARTING_POINT' | translate }}
        </legend>
          <div class="row g-3">
          <!-- RO_ORIGIN_LABEL -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'roOriginLabel'"
              [label]="'SETTINGS.ORIGIN_RO_PLACE' | translate"
              [controlName]="'roOriginLabel'"
              [formGroup]="formGroup()"
              [type]="'text'"
            />
          </div>
          <!-- RO_ORIGIN_LATITUDE -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'roOriginLatitude'"
              [label]="'SETTINGS.RO_ORIGIN_LATITUDE' | translate"
              [controlName]="'roOriginLatitude'"
              [formGroup]="formGroup()"
              [type]="'text'"
            />
          </div>
          <!-- RO_ORIGIN_LONGITUDE -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'roOriginLongitude'"
              [label]="'SETTINGS.RO_ORIGIN_LONGITUDE' | translate"
              [controlName]="'roOriginLongitude'"
              [formGroup]="formGroup()"
              [type]="'text'"/>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-12">
      <fieldset class="p-3 border rounded">
        <legend class="float-none w-auto px-2">
          {{ 'SETTINGS.HUB_STOPS' | translate }}
        </legend>
        <div class="row g-3">
          <!--HUB_STOPS_COUNT-->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'hubStopsCount'"
              [label]="'SETTINGS.HUB_STOPS_COUNT' | translate"
              [controlName]="'hubStopsCount'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"/>
          </div>
          <!--HUB_STOPS_DURATION-->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'hubStopDuration'"
              [label]="'SETTINGS.HUB_STOPS_DURATION' | translate"
              [controlName]="'hubStopDuration'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"/>
          </div>
          <!-- HUB_MAX_WAIT_TIME -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'hubMaxWaitTime'"
              [label]="'SETTINGS.HUB_MAX_WAIT_TIME' | translate"
              [controlName]="'hubMaxWaitTime'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"
            />
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-12">
      <fieldset class="p-3 border rounded">
        <legend class="float-none w-auto px-2">
          {{ 'SETTINGS.EMPLOYEE_TIME_MANAGMENT' | translate }}
        </legend>
        <div class="row g-3">
          <!-- EMPLOYEE_BREAK_DURATION -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'employeeBreakDuration'"
              [label]="'SETTINGS.EMPLOYEE_BREAK_DURATION' | translate"
              [controlName]="'employeeBreakDuration'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"
            />
          </div>
          <!--EMPLOYEE_START_TIME-->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'employeeStartTime'"
              [label]="'SETTINGS.EMPLOYEE_START_TIME' | translate"
              [controlName]="'employeeStartTime'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'hour-minute'"/>
          </div>
          <!--EMPLOYEE_END_TIME-->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'employeeEndTime'"
              [label]="'SETTINGS.EMPLOYEE_END_TIME' | translate"
              [controlName]="'employeeEndTime'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'hour-minute'"/>
          </div>

        </div>
      </fieldset>
    </div>
    <div class="col-12">
      <fieldset class="p-3 border rounded">
        <legend class="float-none w-auto px-2">
          {{ 'SETTINGS.HOLLENSTEIN_STOP' | translate }}
        </legend>
        <div class="row g-3">
          <!--LOCATION_STOP_ID-->
          <div class="col-12 col-md-4">
            <app-link-select
              [controlName]="'location'"
              [formGroup]="formGroup()"
              [id]="'location'"
              [label]="'LOCATIONS.LOCATION' | translate"
              [optionLabelSelector]="[{ selector: 'name' }]"
              [searchService]="locationService"
              [searchValueName]="'name'"
              [baseLink]="'/locations'"
              [queryParams]="[
              { key: 'type', value: 'location' }
              ]"/>
          </div>
          <!--KILOMETER_TRIGGER_RADIUS-->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'kilometerTriggerRadius'"
              [label]="'SETTINGS.KILOMETER_TRIGGER_RADIUS' | translate"
              [controlName]="'kilometerTriggerRadius'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"/>
          </div>
          <!-- HOLLENSTEIN_STOP_DURATION -->
          <div class="col-12 col-md-4">
            <app-form-input
              [id]="'hollsteinStopDuration'"
              [label]="'SETTINGS.HOLLENSTEIN_STOP_DURATION' | translate"
              [controlName]="'hollensteinStopDuration'"
              [formGroup]="formGroup()"
              [isRequired]="true"
              [type]="'number'"
            />
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</form>
